import Core from "@/modules/core/service/Core";
import Assign from "@/modules/dis/service/order/private/Assign";
import Dissolve from "@/modules/dis/service/order/private/Dissolve";
import Common from "@/modules/dis/service/order/private/Common";

const url = {
    order        : "/api/disposition/order",
    orderId      : "/api/disposition/order/{0}",
    assign       : "/api/disposition/order/{0}/unit/{1}",
    assignAll    : "/api/disposition/order/{0}/unit",
    download     : "/api/disposition/order/{0}/documents/zip",
    position     : "/api/disposition/order/position",
    documents    : "/api/disposition/order/{0}/documents",
    createDocs   : "/api/disposition/order/{0}/documents/{1}?recalculate={2}&update={3}"
}

const toOrderDto = function (order) {
    return {
        id      : order.id,
        no      : order.no,
        status  : order.status,
        color   : order.color,
        comment : order.comment,
        customer: order.customer ? {
            id: order.customer.id
        } : null,
        company : order.company  ? {
            id: order.company.id
        } : null,
        scope   : order.scope
    }
}


export default {
    assign  : Assign,
    dissolve: Dissolve,
    common  : Common,

    findAll (filter) {
        if (filter.showAllOrders) {
            return Core.method.get(url.order);
        }

        return Core.method.get(url.order + "?closed=false");
    },

    store (order) {
        if (order.id) {
            return Core.method.put(url.order, toOrderDto(order));
        } else {
            return Core.method.post(url.order, toOrderDto(order));
        }
    },

    delete (order) {
        return Core.method.delete(url.orderId, null, order.id);
    },

    download (orderId, date, success, error) {
        let downloadUrl = url.download.replace("{0}", orderId);
        if (date) {
            downloadUrl = downloadUrl + "?date=" + date;
        }

        Core.transfer.load(downloadUrl, success, error);
    },

    findAvailibleReports(orderId) {
        return Core.method.get(url.documents, orderId);
    },

    report: {
        inspection (orderId, update, inspectionId, recalculate) {
            return Core.method.post(url.createDocs, null, orderId, inspectionId, recalculate, update);
        },
    },

    updateOrderPosition (orderList) {
        orderList.forEach((order,index) => {
            order.position = index + 1;
        });
        const idList = orderList.map (o => o.id);
        return Core.method.putVoid(url.position, idList)
    },
}